import React from 'react';
import { Button, Typography, BaseIcon } from '@scale/scaleui';
import {
  getNewFlowStarterConfig,
  IOnboardingFlow,
  IOnboardingFlowDraft,
} from '@scale/shared/onboardingControlPanel';
import { useOCPStore } from './hooks/useOCPStore';
import { useDraftFlowStore } from './hooks/useDraftFlowStore';
import { useBypassWhitelistStore } from './hooks/useBypassWhitelistStore';
import uuid from 'uuid';
import { Link } from 'react-router-dom';
import { Routes } from 'react-scale/components/GrowthCenter/urls';

const Header: React.FC = () => {
  const { setCurrentFlow, toggleAutofocusFlowName } = useOCPStore(state => ({
    setCurrentFlow: state.setCurrentFlow,
    toggleAutofocusFlowName: state.toggleAutofocusFlowName,
  }));

  const { addDraftFlow } = useDraftFlowStore(state => ({
    addDraftFlow: state.addDraftFlow,
  }));

  const { initializeBypassWhitelist } = useBypassWhitelistStore(state => ({
    initializeBypassWhitelist: state.initializeBypassWhitelist,
  }));

  const createFlow = async () => {
    const newFlowDraft: IOnboardingFlowDraft<string> = {
      ...getNewFlowStarterConfig(),
      _id: `tempId_${uuid.v4().substring(0, 8)}`,
    };
    addDraftFlow(newFlowDraft);
    const newFlow: any = {
      ...newFlowDraft,
      isPublished: false,
    };
    delete newFlow.originalFlowId;
    setCurrentFlow(newFlow as IOnboardingFlow);
    initializeBypassWhitelist(newFlow);
    toggleAutofocusFlowName();
  };

  return (
    <div className="flex flex-row justify-between w-full gap-5 items-center">
      <div>
        <Typography.H4>Onboarding Funnels</Typography.H4>
      </div>

      <Link to={`${Routes.OnboardingControlPanel}/draft`} onClick={() => createFlow()}>
        <Button size="lg" variant="primary">
          <BaseIcon contrastText edge="start" icon={['fas', 'plus']} />
          New Funnel
        </Button>
      </Link>
    </div>
  );
};

export default Header;
